
<div>
  <template>
    every {{
    `${interval.amount}
    ${durationUnitLabelFor(interval.unit)} `}}
    <template v-if="interval.unit === DurationUnit.year">
      on {{ MonthToString[interval.month]+ " " + ordinalize(interval.day)}}
    </template>
    <template v-if="interval.unit === DurationUnit.month">
      on the {{ordinalize(interval.day)}}
    </template>
    <template v-if="interval.unit === DurationUnit.week">
      on {{weekdaysString}}
    </template>
    <template  v-if="interval.unit === DurationUnit.day || interval.unit === DurationUnit.week
     || interval.unit === DurationUnit.month || interval.unit === DurationUnit.year">
      at {{timeOfDayDisplay}}
    </template>
    after the first trigger
    <template v-if="interval.end_type !== IntervalEndType.Never">
      , and ends
      <template v-if="interval.end_type === IntervalEndType.SpecificDate">
        {{intervalEndDate}}
      </template>
      <template v-if="interval.end_type === IntervalEndType.NumberOfOccurrences">
        after {{interval.number_of_occurrences}} occurrences
      </template>
      <template v-if="interval.end_type === IntervalEndType.OnCondition &&  Object.keys(interval.end_condition_conditional_rule_sets).length > 0">
          <template v-for="(ruleSet, index) in interval.getSortedConditionalRuleSets('end_condition')">
            <conditional-display-rule
              :key="ruleSet.client_id"
              :class="{ 'condition-rule': true }"
              :conditional-rule-set="ruleSet"
              :totalRuleSets="Object.keys(interval.end_condition_conditional_rule_sets).length"
              hideSortControls
              :disabled="true">
            </conditional-display-rule>
            <slot name="value" :uniqueId="index" :model="ruleSet" fieldName="conditional_value"></slot>
        </template>
      </template>
    </template>
  </template>
</div>
